<template>
  <div>
    <div class="pb-60">
      <div class="fixed-top">
        <div class="container-fluid bg-primary shadow-sm text-nowrap" style="padding-right: 18px" :class="{'read-only': isReadOnly}" >
          <div class="d-flex justify-content-between align-items-center small top-bar">
            <a href="javascript:" @click="voltar()" class="text-white text-decoration-none font-weight-bold text-ellipsis" style="max-width: 50%">
              <i class="fa fa-chevron-left mr-2" v-if="usuario.id_funcao < 2 || !isReadOnly"></i><span>{{usuario.nome_fantasia}} {{isReadOnly > 1 ? `- PDV ${isReadOnly}` : ''}}</span>
            </a>
            <div>
              <a href="javascript:" class="btn text-white btn-topbar" @click="sincronizar()" title="Sincronizar dados" style="padding: 0 6px 0 6px">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-rotate" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5" />
                </svg>
              </a>
              <a v-if="!is_mobile" :class="{'new-orders': bell && !isComanda}" class="btn text-white btn-topbar" href="javascript:" title="Pedidos LeCard" @click="$refs.listaLeCard.openListaLecard()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chef-hat" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723l0 7.126h-12v-7.126a4 4 0 1 1 2.092 -7.723a4 4 0 0 1 3.908 -3.151z"></path>
                  <path d="M6.161 17.009l11.839 -.009"></path>
                </svg>
                <b class="text-white" v-if="bell && !isComanda">{{ bell }}</b>
              </a>
              <a href="javascript:" class="btn text-white btn-topbar" :class="printsError ? 'animated bounceIn infinite' : ''"
                 @click="$store.state.modalFilaPrint = true" title="Fila de impressão">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-printer" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
                  <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
                  <rect x="7" y="13" width="10" height="8" rx="2" />
                </svg>
                <b class="text-white ml-1" v-if="printsError">{{ printsError }}</b>
              </a>
              <a class="btn text-white btn-topbar" href="javascript:" title="Visualizar clientes" @click="$refs.barCliente.iniciar()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-user-search" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <circle cx="12" cy="7" r="4" />
                  <path d="M6 21v-2a4 4 0 0 1 4 -4h1" />
                  <circle cx="16.5" cy="17.5" r="2.5" />
                  <path d="M18.5 19.5l2.5 2.5" />
                </svg>
              </a>
              <a href="javascript:" class="btn text-white btn-topbar" @click="openCaixa()" title="Visualizar Caixa" v-if="caixa && usuario.id_funcao < 3">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-building-bank" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <line x1="3" y1="21" x2="21" y2="21" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                  <polyline points="5 6 12 3 19 6" />
                  <line x1="4" y1="10" x2="4" y2="21" />
                  <line x1="20" y1="10" x2="20" y2="21" />
                  <line x1="8" y1="14" x2="8" y2="17" />
                  <line x1="12" y1="14" x2="12" y2="17" />
                  <line x1="16" y1="14" x2="16" y2="17" />
                </svg>
              </a>
              <a href="javascript:" class="btn text-white d-none d-sm-inline-block" @click="openPage()" title="Nova janela" style="padding: 0 6px 0 6px">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-square-plus" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                  <line x1="9" y1="12" x2="15" y2="12" />
                  <line x1="12" y1="9" x2="12" y2="15" />
                </svg>
              </a>
              <a v-if="!(isElectron && isReadOnly) || usuario.id_funcao > 2" class="btn text-white btn-topbar" href="javascript:" title="Deslogar do sistema" @click="sair()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-logout" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
                  <path d="M7 12h14l-3 -3m0 6l3 -3" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cliente ref="barCliente" view="true"/>
    <admin-caixas-form/>
    <caixa ref="barCaixa" @finalizarVenda="visualizarCaixa"/>

    <div v-if="!is_mobile">
      <lista-lecard ref="listaLeCard"/>
    </div>

    <version-app :fixed="true"/>
  </div>
</template>

<script>
import AdminCaixasForm from "@/views/comanda/caixa/AdminCaixasForm";
import Caixa from "@/views/comanda/pdv/Caixa";
import ListaLecard from "@/views/comanda/pdv/ListaLecard";
import VersionApp from "@/components/commons/VersionApp";

export default {
  name: 'BarComanda',
  components: {VersionApp, ListaLecard, Caixa, AdminCaixasForm},

  data() {
    return {
      token: localStorage.getItem('key')
    }
  },

  methods: {
    sair() {
      this.$swal({
        title: '',
        text: 'Deseja sair do sistema?',
        buttons: ['Cancelar', 'Sim'],
        dangerMode: true,

      }).then((result) => {
        if (result) {
          this.$store.state.load = "Excluindo os dados";
          this.logout(true);
        }
      });
    },

    sincronizar() {
      this.$store.state.load = "Sincronizando..";
      this.$cache.resetAll();
      window.location.reload();
    },

    openPage() {
      const detail = { url: window.location.href, new_window: true };

      this.$swal({
        text: "Deseja abrir uma nova janela do PDV?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(res => {
        if (res) {
          if (this.isElectron) {
            document.dispatchEvent(new CustomEvent('gopage', { detail }));

          } else {
            window.open(detail.url, '_blank');
          }
        }
      });
    },

    openCaixa() {
      this.$store.state.load = true;
      this.$http.get('caixas/consultar/' + this.token)
        .then(res => {
          this.$store.state.load = false;

          if (res.data.id_caixa) {
            this.visualizarCaixa(res.data.id_caixa);

          } else {
            this.$refs.barCaixa.abrirCaixa();
          }

        }, res => {
          this.$store.state.load = false;
        });
    },

    visualizarCaixa(id_caixa) {
      this.$emit('openModalCaixa', id_caixa);
    },

    voltar() {
      if (this.usuario.id_funcao < 2 || !this.isReadOnly) {
        this.$router.push('/home');
      }
    }
  },

  created() {
    if (this.isReadOnly) {
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#2D3356');
    }

    this.$parent.$on('verCaixa', () => {
      this.openCaixa();
    });
  },

  computed: {
    usuario() {
      return this.$store.state.dataUser
    },

    bell() {
      return this.$store.state.bell.orders
    },

    printsError() {
      return this.$store.state.printsError
    },

    caixa() {
      return this.$store.state.pdv.habilitar_caixa === '1';
    },

    isReadOnly() {
      return this.$store.state.isReadOnly;
    },

    isComanda() {
      return this.$store.state.is_comanda;
    }
  }
}
</script>
<style scoped>
.pb-60 {
  padding-bottom: 56px
}

.pb-40 {
  padding-bottom: 38px
}

.read-only {
  background-color: var(--third)!important;
}

.btn-topbar {
  padding: 0 6px 0 6px;
}

.top-bar {
  min-height: 39px;
}

.new-orders {
  -webkit-animation: new-orders 0.8s linear infinite;
  -moz-animation: new-orders 0.8s linear infinite;
  -ms-animation: new-orders 0.8s linear infinite;
  -o-animation: new-orders 0.8s linear infinite;
  animation: new-orders 0.8s linear infinite;
}

@keyframes new-orders {
  0% { opacity: 0.3 }
  100% { opacity: 1 }
}
</style>
